import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ContractComment.Save.IRequest;
type Response = Api.Core.ContractComment.Save.IResponse;
type Headers = Api.Core.ContractComment.Save.IHeaders;
const url = '/api/Sales/ContractComment';
export default async function contractCommentSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
